'use client';

import { Divider, ErrorState, Heading, Link, Skeleton, Stack, Tag, Text, Wrap } from '@pie/amber';
import { RECENT_ARTICLES_LIMIT, useRecentArticles } from '@/lib/api/blog';
import { Fragment } from 'react';

export const RelatedArticles = () => {
  const { data, status } = useRecentArticles();

  return (
    <Stack gap="layout-xs">
      <Heading className="mb-layout-xs" size="lg">
        Recent Articles
      </Heading>
      {status === 'error' && (
        <ErrorState
          heading="Failed to load"
          helpText="We were unable to load the recent articles. Please try again later."
          size="md"
        />
      )}
      {status === 'pending' &&
        Array.from({ length: RECENT_ARTICLES_LIMIT }, (_, index) => {
          return (
            <Fragment key={index}>
              <Divider emphasis="subtle" />
              <article className="py-layout-xs" data-testid="recent-articles-loading">
                <Skeleton className="w-1/10" size="body-xs" />
                <Skeleton className="mb-layout-2xs mt-2xs w-8/10" size="header-sm" />
                <Skeleton size="body-sm" />
              </article>
            </Fragment>
          );
        })}
      {status === 'success' &&
        data.map((article) => (
          <Fragment key={article.id}>
            <Divider emphasis="subtle" />
            <article className="py-layout-xs">
              <Wrap gap="layout-2xs">
                <Tag emphasis="light" palette="purple" size="sm">
                  {article.category.label}
                </Tag>
                <Text className="text-text-subtle-default" variant="body-xs">
                  {article.readTime} min read
                </Text>
              </Wrap>
              <Link
                className="mb-layout-2xs mt-2xs"
                external
                href={article.url}
                rel="noopener noreferrer"
                target="_blank"
                truncate
                variant="header-sm"
              >
                {article.title}
              </Link>
              <Text className="line-clamp-2" variant="body-sm">
                {article.description}
              </Text>
            </article>
          </Fragment>
        ))}
    </Stack>
  );
};
